export { default } from 'shared/components/menu'
